// @ts-nocheck
import React from 'react';
import {FlatList, View, StyleSheet} from 'react-native';
import Text from '../../../components/Text';
import {useNavigation} from '@react-navigation/native';
import MySearchbar from '../../../components/MySearchbar';
import NavbarWithAction from '../../../components/NavbarWithAction';
import {useDispatch, useSelector} from 'react-redux';
import {RootStore} from '../../../redux/store';
import {Card} from 'react-native-paper';
import {UpdateListEvents} from '../../../redux/reducers/listEventsReducer';
import {ListEvent} from '../../../@types';
import {GetAlerts} from '../alertsReducer';
import Button from '../../../components/Button';
import Center from '../../../components/Center';
import Select from '../../../components/Select';
import VStack from '../../../components/VStack';
import playSound from '../../../service/playSound';
import {
  DEFAULT_NOTIFICATION_SOUND_KEY,
  getBaseNotificationSoundOptions,
  getNotificationSoundOptions,
  NotificationSoundKey,
  NotificationSoundOption,
  resolveNotificationSound,
} from '../../../service/notificationSounds';
import {
  SetNotificationSound,
} from '../../../redux/reducers/notificationSoundReducer';
import {showInformationMessage, showSuccessMessage} from '../../../service/flashMessage';

//We need to store a draftState,
//Initial state is listEvents from store,
//When switch is toggled, update the relevant key in listEvents,
//On submit, update listEvents in store, also need to do the update in local storage
//listEvents always need to be stored locally

export default function Preferences() {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const [isNavbarShown, setIsNavbarShown] = React.useState(true);
  const [searchTerm, setSearchTerm] = React.useState('');
  const listEvents = useSelector(
    (state: RootStore) => state.listEvents.listEvents,
  );
  const selectedSoundKeyFromStore = useSelector(
    (state: RootStore) =>
      state?.notificationSound?.selectedSoundKey ?? DEFAULT_NOTIFICATION_SOUND_KEY,
  );
  const [selectedSoundKey, setSelectedSoundKey] =
    React.useState<NotificationSoundKey>(selectedSoundKeyFromStore);
  const [soundOptions, setSoundOptions] = React.useState<
    NotificationSoundOption[]
  >(getBaseNotificationSoundOptions());
  const [listEventsDraftState, setListEventsDraftState] =
    React.useState<Array<ListEvent>>(listEvents);

  React.useEffect(() => {
    setSelectedSoundKey(selectedSoundKeyFromStore);
  }, [selectedSoundKeyFromStore]);

  React.useEffect(() => {
    void getNotificationSoundOptions().then(setSoundOptions);
  }, []);

  function searchPreferences(searchString: string) {
    const events = listEventsDraftState.filter(event => {
      const descriptionData = event.eventDescription
        ? `${event.eventDescription}`.toUpperCase()
        : `${event.eventName}`.toUpperCase();

      const searchTermData = searchString.toUpperCase();
      return descriptionData.indexOf(searchTermData) > -1;
    });

    setListEventsDraftState(events);
  }

  const currentSound =
    soundOptions.find(option => option.key === selectedSoundKey) ??
    resolveNotificationSound(selectedSoundKey);

  function NotificationSoundSection() {
    return (
      <Card style={styles.soundCard}>
        <View style={styles.soundHeader}>
          <VStack>
            <Text style={styles.soundTitle}>Notification sound</Text>
            <Text style={styles.soundSubtitle}>
              Applies to app-delivered alerts.
            </Text>
          </VStack>
        </View>
        <Text style={styles.soundLabel}>Choose a sound</Text>
        <View style={styles.soundPickerRow}>
          <Select
            placeholder="Select notification sound"
            selectedValue={selectedSoundKey}
            flex={1}
            minWidth={220}
            onValueChange={value =>
              setSelectedSoundKey(value as NotificationSoundKey)
            }>
            {soundOptions.map(option => (
              <Select.Item
                key={option.key}
                label={option.label}
                value={option.key}
              />
            ))}
          </Select>
          <Button
            variant="outline"
            onPress={async () => {
              const previewPlayed = await playSound(
                selectedSoundKey,
                currentSound.label,
              );
              if (!previewPlayed) {
                showInformationMessage(
                  'Sound preview is only available on a device.',
                );
              }
            }}>
            Preview
          </Button>
        </View>
        <Text style={styles.soundDescription}>{currentSound.description}</Text>
      </Card>
    );
  }

  function HeaderSection() {
    if (isNavbarShown) {
      return (
        <NavbarWithAction
          navigation={navigation}
          hasBackArrow
          title="Notification preferences"
        />
      );
    }
    return (
      <MySearchbar
        placeholder="Search  name"
        setValue={(val: string) => {
          setSearchTerm(val);
        }}
        resetSearch={() => {
          setIsNavbarShown(true);
          setSearchTerm('');
        }}
      />
    );
  }

  function updateListEvent(item: ListEvent) {
    const newState = listEventsDraftState.map(event => {
      if (event.id === item.id) {
        return {
          ...event,
          active: !item.active,
        };
      }
      return event;
    });

    setListEventsDraftState([...newState]);
  }

  function ListingSection() {
    return (
      <FlatList
        data={listEventsDraftState}
        ListFooterComponent={<View style={{height: 32}} />}
        ListEmptyComponent={<Center>No preferences found</Center>}
        renderItem={({item}) => (
          <Card
            style={{
              padding: 8,
            }}>
            <View
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
              }}>
              <View
                style={{
                  flexDirection: 'column',
                  flex: 1,
                }}>
                <Text style={{fontSize: 18}}>
                  {item.eventName || 'Unnamed'}
                </Text>
                <Text>{item.eventDescription}</Text>
              </View>
              {/* <Switch
                isChecked={item.active}
                onToggle={() => {
                  if (item.active) {
                    showAlert(
                      `Are you sure you wish to turn off ${
                        item.eventName || 'Unnamed'
                      } alerts ?`,
                      `This will hide ${
                        item.eventName || 'Unnamed'
                      } alerts from your alerts list.`,
                      () => console.log(),
                      () => updateListEvent(item),
                    );

                    return;
                  }
                  updateListEvent(item);
                }}
              /> */}
            </View>
          </Card>
        )}
      />
    );
  }

  return (
    <View style={{flex: 1}}>
      <HeaderSection />
      <NotificationSoundSection />
      <ListingSection />
      <Button
        onPress={() => {
          dispatch(SetNotificationSound(selectedSoundKey));
          dispatch(UpdateListEvents(listEventsDraftState));
          showSuccessMessage('Notification preferences saved');
          setTimeout(() => {
            dispatch(GetAlerts());
            navigation.goBack();
          }, 1000);
        }}
        mb="4"
        py="4"
        mx="2">
        Save
      </Button>
    </View>
  );
}

const styles = StyleSheet.create({
  soundCard: {
    marginHorizontal: 8,
    marginTop: 12,
    marginBottom: 8,
    padding: 16,
    borderRadius: 8,
  },
  soundHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 16,
    marginBottom: 12,
  },
  soundTitle: {
    fontSize: 18,
    fontWeight: '700',
  },
  soundSubtitle: {
    marginTop: 4,
    opacity: 0.7,
  },
  soundLabel: {
    marginBottom: 8,
    fontWeight: '600',
  },
  soundPickerRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  soundDescription: {
    marginTop: 8,
    opacity: 0.75,
  },
});
